<template>
  <div v-if="isTokenParsed">
    <menu-menu />
    <home-cards v-if="canUseApp" />
    <not-authorized v-if="!canUseApp" />
    <Footer />
  </div>
</template>

<script>
import { containsAudience } from '@/utils/helpers';

import MenuMenu from '../components/Menu.vue';
import HomeCards from '../components/HomeCards.vue';
import Footer from '../components/Footer.vue';
import NotAuthorized from '../components/NotAuthorized.vue';

export default {
  name: 'OudoorVision',
  components: { MenuMenu, HomeCards, Footer, NotAuthorized },

  computed: {
    isTokenParsed () {
      return this.$keycloak.tokenParsed != null;
    },

    canUseApp () {
      const { aud = [] } = this.$keycloak.tokenParsed || {};
      return containsAudience(aud, process.env.VUE_APP_API_AUD);
    },
  },
};
</script>
